import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/vehiclemaintenance/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as XLSX from "xlsx";
import moment from "moment";
import { saveAs } from "file-saver";
import {
  faEye,
  faPenToSquare,
  faTrash,
  faHistory,
} from "@fortawesome/free-solid-svg-icons";

import Layouts from "../../layouts/layouts";
import Add_data_modal from "../../components/vehiclemaintenance/update_data_modal";
import MaintenanceDetailModal from "../../components/vehiclemaintenance/Maintenance Details";

export default function Maintenance() {
  const navigate = useNavigate();
  const title = "Vehicle Maintenance Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showMaintenanceDetailModal, setShowMaintenanceDetailModal] =
    useState(false);
  const [selectedMaintenance, setSelectedMaintenance] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD-MM-YYYY");
  };
  const columns = [
    {
      name: <b>Vehicle</b>,
      selector: (row) => (row.vehicle ? row.vehicle.numberplate : "-"),
      sortable: true,
    },
    {
      name: <b>Vehicle Status</b>,
      cell: (row) => {
        const status = row.vehicle?.status?.toLowerCase();

        return (
          <button
            className={`btn px-2 py-1 ${
              status === "active"
                ? "btn-success"
                : status === "inactive"
                  ? "btn-danger"
                  : status === "unassigned"
                    ? "btn-danger"
                    : status === "service_center"
                      ? "btn-warning"
                      : "btn-secondary"
            }`}
            style={{
              minWidth: "110px",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
          >
            {row.vehicle?.status || "Unknown"}
          </button>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: <b>Company</b>,
      selector: (row) => (row.vehicle ? row.vehicle?.id_type?.company : "-"),
      sortable: true,
    },
    {
      name: <b>Service Type</b>,
      selector: (row) => row.serviceType || "-",
      sortable: true,
    },
    {
      name: <b>Last Service Date</b>,
      selector: (row) => formatDate(row.lastServiceDate) || "-",
      sortable: true,
    },
    {
      name: <b>Last Service Km</b>,
      selector: (row) => Math.round(row.lastServiceKm || 0),
      sortable: true,
    },

    {
      name: <b>Next Service Date</b>,
      selector: (row) => formatDate(row.nextServiceDueDate) || "-",
      sortable: true,
    },
    {
      name: <b>Next Service Km</b>,
      selector: (row) => Math.round(row.nextServiceDueKm || 0),
      sortable: true,
    },
    {
      name: <b>Current KM</b>,
      selector: (row) => Math.round(row.vehicle?.totalkm || 0),
      sortable: true,
    },

    {
      name: <b>Amount</b>,
      selector: (row) => row.amount,
      sortable: true,
    },

    {
      name: <b>Status</b>,
      cell: (row) => (
        <button
          onClick={() => handleShow(row)} // Keep this if you want to open modal on click
          className={`btn p-0 px-1 ${
            row.status?.toLowerCase() === "completed" ? "btn-success" : ""
          } ${row.status?.toLowerCase() === "pending" ? "btn-danger" : ""}`}
        >
          {row.status || "Unknown"}
        </button>
      ),
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className="btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          <button
            onClick={() => viewMaintenance(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>

          <button
            onClick={() => handleMaintenanceHistory(row)}
            className="btn btn-warning btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faHistory} />
          </button>
        </>
      ),
    },
  ];
  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const handleMaintenanceHistory = (row) => {
    if (!row.vehicle?._id) {
      Swal.fire("Error", "Vehicle information not found", "error");
      return;
    }

    navigate(`/maintenancehistory/${row.vehicle._id}`);
  };
  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/maintenance-check`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (Array.isArray(response.data)) {
        setApiState(response.data);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const viewMaintenance = (maintenance) => {
    setSelectedMaintenance(maintenance);
    setShowMaintenanceDetailModal(true);
  };
  const updateMaintenance = (updatedMaintenance) => {
    setApiState((prev) =>
      prev.map((maintenance) =>
        maintenance._id === updatedMaintenance._id
          ? updatedMaintenance
          : maintenance,
      ),
    );
  };

  const exportToExcel = () => {
    if (!apistate || apistate.length === 0) {
      Swal.fire(
        "No Data",
        "There is no maintenance data to export.",
        "warning",
      );
      return;
    }

    const exportData = apistate.map((row, index) => ({
      "S.No": index + 1,
      Vehicle: row.vehicle?.numberplate || "-",
      VehicleStatus: row.vehicle?.status || "-",

      ChassisNumber: row.vehicle?.chassisnumber || "-",

      Company: row.vehicle?.id_type?.company || "-",

      "Service Type": row.serviceType || "-",
      "Last Service Date": row.lastServiceDate
        ? formatDate(row.lastServiceDate)
        : "-",
      "Last Service Km": Math.round(row.lastServiceKm || 0),
      "Next Service Date": row.nextServiceDueDate
        ? formatDate(row.nextServiceDueDate)
        : "-",
      "Next Service Km": Math.round(row.nextServiceDueKm || 0),
      "Current KM": Math.round(row.vehicle?.totalkm || 0),
      Amount: row.amount || 0,
      Status: row.status || "-",
      Notes: row.notes || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Maintenance");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(
      file,
      `Vehicle_Maintenance_${new Date().toISOString().slice(0, 10)}.xlsx`,
    );
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateMaintenance={updateMaintenance}
      />
      <MaintenanceDetailModal
        show={showMaintenanceDetailModal}
        onHide={() => setShowMaintenanceDetailModal(false)}
        maintenance={selectedMaintenance}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>

                <button
                  type="button"
                  className="btn btn-success"
                  onClick={exportToExcel}
                >
                  Export to Excel
                </button>
              </div>
              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="vehicle"
                    title_btn={true}
                    title="Vehicle List"
                    apidata={apistate}
                    columns={apicol}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
